// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import questionData from '@/assets/quiz.json';

Vue.use(Vuex);

// クリアデータとどの問題を見ていたかをlocalに保存
const odakyuQuizClearData = {
  namespaced: true,
  state: {
    clearData: {
      grade: 0,
      stage: 0,
    },
  },
  mutations: {
    changeGrade(state, grade) {
      state.clearData.grade = grade;
    },
    changeStage(state, stage) {
      state.clearData.stage = stage;
    },
    setClearData(state) {
      const localdata = JSON.parse(localStorage.getItem('odakyuQuizClearData'));
      Object.keys(state).forEach((key) => {
        if (localdata.odakyuQuizClearData[key] !== null) {
          state[key] = localdata.odakyuQuizClearData[key];
        } else {
          state[key] = 0;
        }
      });
    },
  },
};

// 級・ステージ選択画面でどのレベルを選択したのかを保持
const selectLevel = {
  namespaced: true,
  state: {
    selectLevel: {
      grade: 0,
      stage: 0,
      questionCount: 1,
    },
  },
  mutations: {
    setSelectLevel(state, level) {
      state.selectLevel.grade = level.grade;
      state.selectLevel.stage = level.stage;
      state.selectLevel.questionCount = level.questionCount;
    },
  },
};

// 最後に見た問題を保存
const odakyuQuizLoadData = {
  namespaced: true,
  state: {
    loadData: {
      grade: 0,
      stage: 0,
      questionCount: 1,
    },
  },
  mutations: {
    saveLoadData(state, data) {
      state.loadData.grade = data.grade;
      state.loadData.stage = data.stage;
      state.loadData.questionCount = data.questionCount;
    },
    setLoadData(state) {
      const localdata = JSON.parse(localStorage.getItem('odakyuQuizLoadData'));
      Object.keys(state).forEach((key) => {
        if (localdata.odakyuQuizLoadData[key] !== null) {
          state[key] = localdata.odakyuQuizLoadData[key];
        } else {
          state[key] = 0;
        }
      });
    },
  },
};

// すべての問題データを取得
const quizJSON = {
  namespaced: true,
  state: {
    questionData,
  },
};

// 表示するコンポーネント名を保持
const currentPage = {
  namespaced: true,
  state: {
    page: 'start',
  },
  mutations: {
    changeCurrentPage(state, page) {
      state.page = page;
    },
  },
};

// 表示するコンポーネント名を保持
const odakyuQuizQuestionNumArr = {
  namespaced: true,
  state: {
    questionNumArr: '',
  },
  mutations: {
    changeQuestionNumArr(state, arr) {
      state.questionNumArr = arr;
    },
    setQuestionNum(state) {
      const localdata = JSON.parse(localStorage.getItem('odakyuQuizQuestionNumArr'));
      Object.keys(state).forEach((key) => {
        if (localdata.odakyuQuizData.odakyuQuizQuestionNumArr[key] !== null) {
          state[key] = localdata.odakyuQuizData.odakyuQuizQuestionNumArr[key];
        } else {
          state[key] = 0;
        }
      });
    },
  },
};

export default new Vuex.Store({
  modules: {
    odakyuQuizClearData,
    odakyuQuizLoadData,
    selectLevel,
    quizJSON,
    currentPage,
    odakyuQuizQuestionNumArr,
  },
  // 以下のstateが変更されたら自動的にlocalstorageに保存される
  plugins: [createPersistedState(
    {
      key: 'odakyuQuizData',
      paths: [
        'odakyuQuizClearData.clearData',
        'odakyuQuizLoadData.loadData',
        'odakyuQuizQuestionNumArr.questionNumArr',
      ],
    },
  )],
});



// WEBPACK FOOTER //
// ./src/store.js